<template lang="pug">
  .drawer-preview
    p DRAWER PREVIEW
</template>

<script>

export default {
  data () {
    return {}
  },
  mounted () {

  }
}

</script>
